<template>
  <div class="box-func" name="hrms15e-detail">
    <div class="detail detail-responsive clearfix">
      <div class="col-md-4 clear-padding-mb" v-if="!detail3Desc3Disabled">
        <div v-if="!detailDisabled">
          <div class="custom-border clearfix">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
                <div class="col-md-3">
                  <div class="form-control readonly-field-color" >{{ setYearOutput(searchIndex.year) }}</div>
                </div>
                <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
                <div class="col-md-3">
                  <div class="form-control readonly-field-color">{{ searchIndex.numtime }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['30'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color" >{{ indexSelected.numseq }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ codappr }} - {{ descCodappr }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['35'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color" v-if="indexSelected.flgtypap === 'C'" >{{ labels['HRAP31EC2']['220'] }}</div>
                  <div class="form-control readonly-field-color" v-else >{{ labels['HRAP31EC2']['230'] }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['50'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dteapman) }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dteapstr) }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dteapend) }}</div>
                </div>
              </div>
            </form>
            <div class="box-footer padding-b-0">
              <div class="col-md-6 clear-padding">
                <button type="button" class="btn bg-dark-gray" v-if="showDetailDescDisp" @click="toggleTab1Desc1Back()"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
              </div>
            </div>
          </div>

          <div  v-if="!showDetailDescDisp">
            <div class="custom-border clearfix" >
              <div class="detail-header"><h4><u>{{ labels['HRAP31EC2']['110'] }}</u></h4></div>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label"></label>
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['140'] }}</label>
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['120'] }}</label>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['150'] }}</label>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.qtybeh }}</div>
                  </div>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.avgbeh }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['160'] }}</label>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.qtycmp }}</div>
                  </div>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.avgcmp }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['170'] }}</label>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.qtykpi }}</div>
                  </div>
                  <div class="col-md-4 align-r">
                    <div class="form-control readonly-field-color">{{ sumscore.avgkpi }}</div>
                  </div>
                </div>
              </form>
            </div>
            <div class="custom-border">
              <form class="form-horizontal" >
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['190'] }}</label>
                  <div class="col-md-8 ">
                    <input type="radio" name="R1" id="flgappr1" v-model="indexSelected.flgappr" value="P"/>
                    <span class="radio-text">In Process</span>

                    <input type="radio" name="R2" id="flgappr2" v-model="indexSelected.flgappr" value="C"/>
                    <span class="radio-text">Completed</span>
                  </div>
                </div>
              </form>
              <div >
                <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
                <button type="button" class="btn bg-color-skin" @click="callSave()" value="save" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
                <button type="button" class="btn bg-color-skin" @click="callSendmail()" :disabled="flgDisabled"><i class="fa fa-envelope"></i>{{ labelsButton['sendmail'] }}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="custom-border clearfix" v-if="detailDisabled1">
          <div class="detail-header"><h4><u>{{ labels['HRAP31EC3']['230'] }}</u></h4></div>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab1Desc2Selected.dteyreap }}</div>
              </div>
              <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab1Desc2Selected.numtime }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab1Desc2Selected.codappr }} - {{ detailTab1Desc2Selected.desc_codappr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['50'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab1Desc2Selected.dteapman }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab1Desc2Selected.dteapstr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab1Desc2Selected.dteapend }}</div>
              </div>
            </div>
          </form>
          <div class="box-footer padding-b-0">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-dark-gray" @click="triggerBack()"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
            </div>
          </div>
        </div>

        <div class="custom-border clearfix " v-if="detailDisabled2">
          <div class="detail-header"><h4><u>{{ labels['HRAP31EC3']['230'] }}</u></h4></div>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab2Desc2Selected.dteyreap }}</div>
              </div>
              <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab2Desc2Selected.numtime }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab2Desc2Selected.codappr }} - {{ detailTab2Desc2Selected.desc_codappr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['50'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab2Desc2Selected.dteapman }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab2Desc2Selected.dteapstr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab2Desc2Selected.dteapend }}</div>
              </div>
            </div>
          </form>
          <div class="box-footer padding-b-0">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-dark-gray" @click="triggerBack()"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
            </div>
          </div>
        </div>

        <div class="custom-border clearfix" v-if="detail3Desc1Disp">
          <div class="detail-header"><h4><u>{{ labels['HRAP31EC3']['230'] }}</u></h4></div>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab3Desc1Selected.dteyreap }}</div>
              </div>
              <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab3Desc1Selected.numtime }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.codappr }} - {{ detailTab3Desc1Selected.desc_codappr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['50'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.dteapman }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.dteapstr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc1Selected.dteapend }}</div>
              </div>
            </div>
          </form>
          <div class="box-footer padding-b-0">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoOthersBack()" v-show="!detail3InfoDesc1Disp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
              <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoOthersBack2()" v-show="detail3InfoDesc1Disp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
            </div>
          </div>
        </div>

        <div class="custom-border clearfix" v-if="detail3Desc2Disp">
          <div class="detail-header"><h4><u>{{ labels['HRAP31EC5']['210'] }}</u></h4></div>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab3Desc2.detail.dteyreap }}</div>
              </div>

              <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color align-c" >{{ detailTab3Desc2.detail.numtime }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC7']['25'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color align-c">{{ detailTab3Desc2.detail.numseq }}</div>
              </div>
            </div>
          </form>
          <!-- <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.codappr }} - {{ detailTab3Desc2.detail.desc_codappr }}</div>
              </div>
            </div>
          </form> -->
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC7']['30'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
              </div>
            </div>
          </form>
          <!-- <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.dteapman }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.dteapstr }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc2.detail.dteapend }}</div>
              </div>
            </div>
          </form> -->

          <div class="box-footer padding-b-0">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoLastBack()" v-show="!detail3InfoDesc1Disp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
              <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoLastBack2()" v-show="detail3InfoDesc1Disp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
            </div>
          </div>
        </div>

        <div  v-if="detail3InfoLeftDisp">
          <div class="custom-border clearfix">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['10'] }}</label>
                <div class="col-md-3">
                  <div class="form-control readonly-field-color" >{{ searchIndex.year }}</div>
                </div>
                <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC3']['20'] }}</label>
                <div class="col-md-3">
                  <div class="form-control readonly-field-color">{{ searchIndex.numtime }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['30'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color" >{{ indexSelected.numseq }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['40'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ codappr }} - {{ descCodappr }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['50'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['60'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ indexSelected.dteapman }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['70'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ indexSelected.dteapstr }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['80'] }}</label>
                <div class="col-md-8">
                  <div class="form-control readonly-field-color">{{ indexSelected.dteapend }}</div>
                </div>
              </div>
            </form>
            <div class="box-footer padding-b-0">
              <div class="col-md-6 clear-padding">
                <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoBack()" v-show="!showDetailDescDisp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
                <button type="button" class="btn bg-dark-gray" @click="toggleTab3InfoDesc1Back()" v-show="showDetailDescDisp"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
              </div>
            </div>
          </div>

          <div class="custom-border" v-if="!showDetailDescDisp" >
            <div class="detail-header"><h4><u>{{ labels['HRAP31EC2']['110'] }}</u></h4></div>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label"></label>
                <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['140'] }}</label>
                <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['120'] }}</label>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['150'] }}</label>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.qtybeh }}</div>
                </div>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.avgbeh }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['160'] }}</label>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.qtycmp }}</div>
                </div>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.avgcmp }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC2']['170'] }}</label>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.qtykpi }}</div>
                </div>
                <div class="col-md-4 align-r">
                  <div class="form-control readonly-field-color">{{ sumscore.avgkpi }}</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-md-4 clear-padding-mb" v-if="detail3Desc3Disabled">
        <div class="custom-border clearfix">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['10'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.dteyreap }}</div>
              </div>

              <label class="col-md-2 control-label time-label">{{ labels['HRAP31EC10']['20'] }}</label>
              <div class="col-md-3">
                <div class="form-control readonly-field-color" >{{ detailTab3Desc3Selected.numtime }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['30'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.desc_codcomp }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['50'] }}</label>
              <div class="col-md-8">
                <textarea  class="form-control" readonly> {{ detailTab3Desc3Selected.kpiitem }}</textarea>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['60'] }}</label>
              <div class="col-md-8">
                <textarea  class="form-control" readonly>{{ detailTab3Desc3Selected.target }}</textarea>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['70'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.mtrunit }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['90'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.dtetarg }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['80'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.mtrvalue }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['110'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.mtrfinish }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['100'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.kpiwgt }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['120'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.grdap }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRAP31EC10']['130'] }}</label>
              <div class="col-md-8">
                <div class="form-control readonly-field-color">{{ detailTab3Desc3Selected.wgttot }}</div>
              </div>
            </div>
          </form>
          <div class="box-footer padding-b-0">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-dark-gray" @click="toggleTab3Desc3Back()"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 clear-padding-mb">
        <div class="topic-button align-center">
          <button v-show="indexSelected.pctbeh !== '0'" type="button" class="btn btn-width" :class=" [ detail1Btn1Disp ? 'bg-color-skin' : 'bg-white color-skin' ] " @click="toggleBtn(1)">{{ labels['HRAP31EC2']['150'] }}</button>
          <button v-show="indexSelected.pctcmp !== '0'" type="button" class="btn btn-width" :class=" [ detail2Btn2Disp ? 'bg-color-skin' : 'bg-white color-skin' ] " @click="toggleBtn(2)">{{ labels['HRAP31EC2']['160'] }}</button>
          <button v-show="indexSelected.pctkpi !== '0'" type="button" class="btn btn-width" :class=" [ detail3Btn3Disp ? 'bg-color-skin' : 'bg-white color-skin' ] " @click="toggleBtn(3)">{{ labels['HRAP31EC2']['170'] }}</button>
        </div>
        <div v-if="flgProcess"><br><br><div class="infinite-loading-container"><i class="loading-default"></i></div></div>
        <div v-else class="custom-border clearfix">
          <div v-show="detail1Btn1Disp">
            <detail1  :detailDisabled="detailDisabled"
                      :setDetailDisabled="setDetailDisabled"
                      :detailDisabled1="detailDisabled1"
                      :setDetailDisabled1="setDetailDisabled1"
                      :labels="labels"
                      :labelsButton="labelsButton"
                      :dropdowns="dropdowns"
                      :detail="detail.tab1"
                      :detailAll="detail"
                      :detailCourse="detailCourse"
                      :detail1Desc1Table="detail1Desc1Table"
                      :nowLang="nowLang"
                      :toggle="toggle"
                      :indexSelected="indexSelected"
                      :searchIndex="searchIndex"
                      :receivedHrms15eDetailCourse="receivedHrms15eDetailCourse"
                      :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                      :receivedHrms15eDetail1Desc2="receivedHrms15eDetail1Desc2"
                      :postDetail1Save="postDetail1Save"
                      :postDetailCourseSave="postDetailCourseSave"
                      :detailTab1Desc2="detailTab1Desc2"
                      :detailTab1Desc2Selected="detailTab1Desc2Selected"
                      :setDetailTab1Desc2Selected="setDetailTab1Desc2Selected"
                      :showDetailDescDisp="showDetailDescDisp"
                      :setShowDetailDescDisp="setShowDetailDescDisp"
                      :detail1Disp="detail1Disp"
                      :setDetail1Disp="setDetail1Disp"
                      :detail1Desc1Disp="detail1Desc1Disp"
                      :setDetail1Desc1Disp="setDetail1Desc1Disp"
                      :detailTab1Desc2IndexSelected="detailTab1Desc2IndexSelected"
                      :setDetailTab1Desc2IndexSelected="setDetailTab1Desc2IndexSelected"
                      :validateStaappr="validateStaappr"
                      :labelsHrms15e="labelsHrms15e"
                      :checkCompleteAll="checkCompleteAll"
                      :calResultScore="calResultScore"
                      :calTotalScore="calTotalScore"
                      ref="detail1"
                      />
          </div>

          <div v-show="detail2Btn2Disp">
            <detail2  :detailDisabled="detailDisabled"
                      :setDetailDisabled="setDetailDisabled"
                      :detailDisabled2="detailDisabled2"
                      :setDetailDisabled2="setDetailDisabled2"
                      :labels="labels"
                      :labelsButton="labelsButton"
                      :detail="detail.tab2"
                      :detailAll="detail"
                      :detailCourse="detailCourse"
                      :popupCourseGap="popupCourseGap"
                      :detail2Desc1Table="detail2Desc1Table"
                      :courseGapPopupTable="courseGapPopupTable"
                      :nowLang="nowLang"
                      :toggle="toggle"
                      :indexSelected="indexSelected"
                      :searchIndex="searchIndex"
                      :receivedHrms15eDetailCourse="receivedHrms15eDetailCourse"
                      :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                      :receivedHrms15eCourseGapPopup="receivedHrms15eCourseGapPopup"
                      :receivedHrms15eDetail2Desc2="receivedHrms15eDetail2Desc2"
                      :postDetail2Save="postDetail2Save"
                      :postDetailCourseSave="postDetailCourseSave"
                      :setDetailCouresAddInlineAll="setDetailCouresAddInlineAll"
                      :setShowDetailDescDisp="setShowDetailDescDisp"
                      :detail1Disp="detail1Disp"
                      :setDetail1Disp="setDetail1Disp"
                      :detail1Desc1Disp="detail1Desc1Disp"
                      :setDetail1Desc1Disp="setDetail1Desc1Disp"
                      :detailTab2Desc2="detailTab2Desc2"
                      :detailTab2Desc2Selected="detailTab2Desc2Selected"
                      :setDetailTab2Desc2Selected="setDetailTab2Desc2Selected"
                      :detailTab2Desc2IndexSelected="detailTab2Desc2IndexSelected"
                      :setDetailTab2Desc2IndexSelected="setDetailTab2Desc2IndexSelected"
                      :validateStaappr="validateStaappr"
                      :labelsHrms15e="labelsHrms15e"
                      :checkCompleteAll="checkCompleteAll"
                      :calResultScore="calResultScore"
                      :calTotalScore="calTotalScore"
                      ref="detail2"
                      />
          </div>

          <div v-show="detail3Btn3Disp">
            <detail3  :detailDisabled="detailDisabled"
                      :setDetailDisabled="setDetailDisabled"
                      :detailDisabled2="detailDisabled2"
                      :setDetailDisabled2="setDetailDisabled2"
                      :detail3Desc3Disabled="detail3Desc3Disabled"
                      :setDetail3Desc3Disabled="setDetail3Desc3Disabled"
                      :detail3Disp="detail3Disp"
                      :setDetail3Disp="setDetail3Disp"
                      :detail3Desc3Disp="detail3Desc3Disp"
                      :setDetail3Desc3Disp="setDetail3Desc3Disp"
                      :detail3InfoDisp="detail3InfoDisp"
                      :setDetail3InfoDisp="setDetail3InfoDisp"
                      :setDetail3InfoLeftDisp="setDetail3InfoLeftDisp"
                      :labels="labels"
                      :labelsButton="labelsButton"
                      :dropdowns="dropdowns"
                      :detail="detail.tab3"
                      :detailAll="detail"
                      :detailCourse="detailCourse"
                      :detail3Desc2Table="detail3Desc2Table"
                      :detail3Desc3Table="detail3Desc3Table"
                      :detail3InfoTable="detail3InfoTable"
                      :nowLang="nowLang"
                      :toggle="toggle"
                      :indexSelected="indexSelected"
                      :detail3Selected="detail3Selected"
                      :setDetail3Selected="setDetail3Selected"
                      :searchIndex="searchIndex"
                      :receivedHrms15eDetail3Desc1="receivedHrms15eDetail3Desc1"
                      :receivedHrms15eDetail3Desc2="receivedHrms15eDetail3Desc2"
                      :receivedHrms15eDetail3Desc3="receivedHrms15eDetail3Desc3"
                      :receivedHrms15eDetail3Info="receivedHrms15eDetail3Info"
                      :receivedHrms15eDetailCourse="receivedHrms15eDetailCourse"
                      :postDetail3InfoSave="postDetail3InfoSave"
                      :detail3InfoDesc1Disp="detail3InfoDesc1Disp"
                      :setDetail3InfoDesc1Disp="setDetail3InfoDesc1Disp"
                      :inlineDetail3Info="inlineDetail3Info"
                      :setInlineDetail3Info="setInlineDetail3Info"
                      :popupDetail3InfoDesc2="popupDetail3InfoDesc2"
                      :detail3InfoDesc1Table="detail3InfoDesc1Table"
                      :detail3InfoDesc2PopupTable="detail3InfoDesc2PopupTable"
                      :receivedHrms15eCourseGapPopup="receivedHrms15eCourseGapPopup"
                      :receivedHrms15eDetail3InfoDesc2Popup="receivedHrms15eDetail3InfoDesc2Popup"
                      :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                      :postDetailCourseSave="postDetailCourseSave"
                      :detailTab3Desc3Selected="detailTab3Desc3Selected"
                      :setDetailTab3Desc3Selected="setDetailTab3Desc3Selected"
                      :detail3Info="detail3Info"
                      :detail3InfoSelected="detail3InfoSelected"
                      :setDetail3InfoSelected="setDetail3InfoSelected"
                      :detailDisabled3="detailDisabled3"
                      :setDetailDisabled3="setDetailDisabled3"
                      :detailTab3Desc1="detailTab3Desc1"
                      :detailTab3Desc1Selected="detailTab3Desc1Selected"
                      :setDetailTab3Desc1Selected="setDetailTab3Desc1Selected"
                      :detailTab3Desc2="detailTab3Desc2"
                      :detail3Desc1Disp="detail3Desc1Disp"
                      :setDetail3Desc1Disp="setDetail3Desc1Disp"
                      :detail3Desc2Disp="detail3Desc2Disp"
                      :setDetail3Desc2Disp="setDetail3Desc2Disp"
                      :setShowDetailDescDisp="setShowDetailDescDisp"
                      :detail3InfoDesc1CourseDisp="detail3InfoDesc1CourseDisp"
                      :setDetail3InfoDesc1CourseDisp="setDetail3InfoDesc1CourseDisp"
                      :detailTab3Desc3="detailTab3Desc3"
                      :detail3InfoIndexSelected="detail3InfoIndexSelected"
                      :setDetail3InfoIndexSelected="setDetail3InfoIndexSelected"
                      :detailTab3Desc3IndexSelected="detailTab3Desc3IndexSelected"
                      :setDetailTab3Desc3IndexSelected="setDetailTab3Desc3IndexSelected"
                      :validateStaappr="validateStaappr"
                      :toggleTab3InfoBack="toggleTab3InfoBack"
                      :labelsHrms15e="labelsHrms15e"
                      :checkCompleteAll="checkCompleteAll"
                      :calResultScore="calResultScore"
                      :calTotalScore="calTotalScore"
                      ref="detail3"
                      />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import detail1 from 'components/hrms15e/detail1'
import detail2 from 'components/hrms15e/detail2'
import detail3 from 'components/hrms15e/detail3'
import { constLabels } from 'assets/js/constLabels.js'
import swal from 'sweetalert'
import _ from 'lodash'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms15e-detail',
  props: [
    'searchIndex',
    'labels',
    'labelsButton',
    'maxRowspan',
    'dropdowns',
    'detail',
    'detailCourse',
    'toggle',
    'nowLang',
    'indexSelected',
    'detail3Selected',
    'setDetail3Selected',
    'codappr',
    'descCodappr',
    'detailDisabled',
    'setDetailDisabled',
    'detailDisabled2',
    'setDetailDisabled2',
    'detail3Desc3Disabled',
    'setDetail3Desc3Disabled',
    'detail3Disp',
    'setDetail3Disp',
    'detail3Desc3Disp',
    'setDetail3Desc3Disp',
    'detail3InfoDisp',
    'setDetail3InfoDisp',
    'popupCourseGap',
    'detail1Desc1Table',
    'courseGapPopupTable',
    'receivedHrms15eDetailCourse',
    'receivedHrms15eDetailCourseAddInline',
    'receivedHrms15eCourseGapPopup',
    'receivedHrms15eDetail1Desc2',
    'postDetailCourseSave',
    'setDetailCouresAddInlineAll',
    'detail2Desc1Table',
    'receivedHrms15eDetail2Desc2',
    'detail3Desc2Table',
    'detail3Desc3Table',
    'detail3InfoTable',
    'receivedHrms15eDetail3Desc1',
    'receivedHrms15eDetail3Desc2',
    'receivedHrms15eDetail3Desc3',
    'receivedHrms15eDetail3Info',
    'receivedHrms15eDetail3InfoDesc1',
    'postDetail3InfoSave',
    'detail3InfoDesc1Disp',
    'setDetail3InfoDesc1Disp',
    'inlineDetail3Info',
    'setInlineDetail3Info',
    'popupDetail3InfoDesc2',
    'detail3InfoDesc1Table',
    'detail3InfoDesc2PopupTable',
    'receivedHrms15eDetail3InfoDesc2Popup',
    'postStatusSave',
    'postSendmail',
    'postDetail1Save',
    'postDetail2Save',
    'detailTab3Desc3Selected',
    'setDetailTab3Desc3Selected',
    'detail3Info',
    'detail3InfoSelected',
    'setDetail3InfoSelected',
    'detailTab1Desc2',
    'detailTab1Desc2Selected',
    'setDetailTab1Desc2Selected',
    'showDetailDescDisp',
    'setShowDetailDescDisp',
    'detailDisabled1',
    'setDetailDisabled1',
    'detail1Disp',
    'setDetail1Disp',
    'detail1Desc1Disp',
    'setDetail1Desc1Disp',
    'detailTab2Desc2',
    'detailTab2Desc2Selected',
    'setDetailTab2Desc2Selected',
    'detailDisabled3',
    'setDetailDisabled3',
    'detailTab3Desc1',
    'detailTab3Desc1Selected',
    'setDetailTab3Desc1Selected',
    'detail3Desc1Disp',
    'setDetail3Desc1Disp',
    'detailTab3Desc2',
    'detail3Desc2Disp',
    'setDetail3Desc2Disp',
    'detail3InfoLeftDisp',
    'setDetail3InfoLeftDisp',
    'detail3InfoDesc1CourseDisp',
    'setDetail3InfoDesc1CourseDisp',
    'detailTab3Desc3',
    'flgDisabled',
    'detail3InfoIndexSelected',
    'setDetail3InfoIndexSelected',
    'detailTab3Desc3IndexSelected',
    'setDetailTab3Desc3IndexSelected',
    'sumscore',
    'detailTab1Desc2IndexSelected',
    'setDetailTab1Desc2IndexSelected',
    'detailTab2Desc2IndexSelected',
    'setDetailTab2Desc2IndexSelected',
    'validateStaappr',
    'flgProcess',
    'labelsHrms15e'
  ],
  data () {
    return {
      detail1Btn1Disp: false,
      detail2Btn2Disp: false,
      detail3Btn3Disp: false
    }
  },
  created () {
    this.setBtnDisp()
  },
  watch: {
    indexSelected () {
      this.setBtnDisp()
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    toggleBtn (btnNo) {
      this.detail1Btn1Disp = false
      this.detail2Btn2Disp = false
      this.detail3Btn3Disp = false
      switch (btnNo) {
        case 1:
          this.detail1Btn1Disp = true
          this.setDetailDisabled(false)
          this.setDetailDisabled1(false)
          this.setDetailDisabled2(false)
          this.setDetailDisabled3(false)
          this.setDetail1Disp(true)
          this.setDetail1Desc1Disp(false)
          this.setShowDetailDescDisp(false)
          this.setDetail3Desc1Disp(false)
          this.setDetail3Desc2Disp(false)
          this.setDetail3Disp(true)
          this.setDetail3Desc3Disp(false)
          this.setDetail3InfoDisp(false)
          this.setDetail3InfoLeftDisp(false)
          this.setDetail3Desc3Disabled(false)
          break
        case 2:
          this.detail2Btn2Disp = true
          this.setDetailDisabled(false)
          this.setDetailDisabled1(false)
          this.setDetailDisabled2(false)
          this.setDetailDisabled3(false)
          this.setDetail1Disp(true)
          this.setDetail1Desc1Disp(false)
          this.setShowDetailDescDisp(false)
          this.setDetail3Desc1Disp(false)
          this.setDetail3Desc2Disp(false)
          this.setDetail3Disp(true)
          this.setDetail3Desc3Disp(false)
          this.setDetail3InfoDisp(false)
          this.setDetail3InfoLeftDisp(false)
          this.setDetail3Desc3Disabled(false)
          break
        case 3:
          this.detail3Btn3Disp = true
          this.setDetailDisabled(false)
          this.setDetailDisabled1(false)
          this.setDetailDisabled2(false)
          this.setDetailDisabled3(false)
          this.setDetail1Disp(true)
          this.setDetail1Desc1Disp(false)
          this.setShowDetailDescDisp(false)
          this.setDetail3Desc1Disp(false)
          this.setDetail3Desc2Disp(false)
          this.setDetail3Disp(true)
          this.setDetail3Desc3Disp(false)
          this.setDetail3InfoDisp(false)
          this.setDetail3InfoLeftDisp(false)
          this.setDetail3Desc3Disabled(false)
          break
        default:
          this.detail1Btn1Disp = true
          break
      }
    },
    triggerBack () {
      window.scrollTo(0, 0)
      this.setDetailDisabled(false)
      this.setDetailDisabled1(false)
      this.setDetailDisabled2(false)
      this.setDetailDisabled3(false)
      this.setDetail3Desc1Disp(false)
      this.setDetail3Desc2Disp(false)
    },
    toggleTab1Desc1Back () {
      this.setDetail1Disp(true)
      this.setDetail1Desc1Disp(false)
      this.setShowDetailDescDisp(false)
    },
    toggleTab3Desc3Back () {
      this.setDetail3Disp(true)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(false)
      this.setDetail3InfoLeftDisp(false)
      this.setDetail3Desc3Disabled(false)
    },
    toggleTab3InfoBack () {
      this.setDetailDisabled(false)
      this.setDetail3Disp(true)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(false)
      this.setDetail3InfoLeftDisp(false)
      this.setDetail3Desc3Disabled(false)
      this.setDetail3InfoDesc1Disp(false)
    },
    toggleTab3InfoDesc1Back () {
      this.setShowDetailDescDisp(false)
      this.setDetail3InfoDisp(true)
      this.setDetail3InfoDesc1Disp(true)
      this.setDetail3InfoDesc1CourseDisp(false)
    },
    toggleTab3InfoOthersBack () {
      this.setDetailDisabled(false)
      this.setDetailDisabled3(false)
      this.setDetail3Desc1Disp(false)
    },
    toggleTab3InfoOthersBack2 () {
      this.setDetailDisabled(true)
      this.setDetail3Disp(true)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(false)
      this.setDetail3InfoDesc1Disp(false)
      this.setDetail3InfoLeftDisp(false)
    },
    toggleTab3InfoLastBack () {
      this.setDetailDisabled(false)
      this.setDetailDisabled3(false)
      this.setDetail3Desc2Disp(false)
    },
    toggleTab3InfoLastBack2 () {
      this.setDetailDisabled(true)
      this.setDetail3Disp(true)
      this.setDetail3Desc3Disp(false)
      this.setDetail3InfoDisp(false)
      this.setDetail3InfoDesc1Disp(false)
      this.setDetail3InfoLeftDisp(false)
    },
    calResultScore (dataGroups) {
      if (dataGroups.length > 0) {
        let aaa = dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
        return (aaa > 0) ? aaa.toFixed(2) : 0.00
      }
    },
    calTotalScore (dataGroups) {
      if (dataGroups.length > 0) {
        return dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyfscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        }).toFixed(2)
      }
    },
    setBtnDisp () {
      if (this.indexSelected.pctbeh !== '0') {
        this.toggleBtn(1)
      } else if (this.indexSelected.pctcmp !== '0') {
        this.toggleBtn(2)
      } else {
        this.toggleBtn(3)
      }
    },
    saveParams () {
      let calQtyBeh = this.calResultScore(this.detail.tab1.table.rows) * 100 / this.calTotalScore(this.detail.tab1.table.rows)
      let calQtyCmp = this.calResultScore(this.detail.tab2.table.rows) * 100 / this.calTotalScore(this.detail.tab2.table.rows)
      return {
        codempid_query: this.indexSelected.codempid,
        dteyreap: this.searchIndex.year,
        numtime: this.searchIndex.numtime,
        numseq: this.indexSelected.numseq,
        codcomp: this.indexSelected.codcomp,
        codpos: this.indexSelected.codpos,
        numlvl: this.indexSelected.numlvl,
        qtybeh: isNaN(calQtyBeh) ? '0' : calQtyBeh + '',
        qtycmp: isNaN(calQtyCmp) ? '0' : calQtyCmp + '',
        qtykpi: this.sumscore.qtykpi,
        dteapman: this.indexSelected.dteapman.replace(/\//g, ''),
        dteapstr: this.indexSelected.dteapstr.replace(/\//g, ''),
        dteapend: this.indexSelected.dteapend.replace(/\//g, ''),
        flgappr: this.indexSelected.flgappr,
        flgtypap: this.indexSelected.flgtypap,
        codaplvl: this.indexSelected.codaplvl
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let _this = this
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              let flgComplete1 = _this.checkCompleteAll(_this.detail.tab1.table.rows)
              let flgComplete2 = _this.checkCompleteAll(_this.detail.tab2.table.rows)
              if (!flgComplete1 || !flgComplete2) {
                swal({
                  title: constLabels('confirmTitle'),
                  text: _this.labelsHrms15e['C100'],
                  html: true,
                  showCancelButton: true,
                  closeOnConfirm: false,
                  confirmButtonText: constLabels('ok'),
                  cancelButtonText: constLabels('cancel')
                },
                function (isConfirm2) {
                  if (isConfirm2) {
                    _this.processSave()
                  }
                })
              } else {
                _this.processSave()
              }
            }
          })
        }
      })
    },
    processSave () {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      this.$refs.detail1.saveDetail1(true)
      this.$refs.detail2.saveDetail2(true)
      this.$refs.detail3.$refs.detail3Info.saveDetail3(true)
      this.postStatusSave({ saveParams: this.saveParams(), searchIndex: this.searchIndex })
    },
    sendmailParams () {
      return {
        codempid_query: this.indexSelected.codempid,
        dteyreap: this.searchIndex.year,
        numtime: this.searchIndex.numtime,
        numseq: this.indexSelected.numseq,
        codaplvl: this.indexSelected.codaplvl
      }
    },
    callSendmail () {
      this.postSendmail({ sendmailParams: this.sendmailParams(), searchIndex: this.searchIndex })
    },
    checkCompleteAll (dataRows) {
      let flgComplete = true
      _.each(dataRows, function (group, keyGroup) {
        if (flgComplete) {
          _.each(group.numitem, function (item, keyItem) {
            if (flgComplete) {
              if (item.graditem === '') {
                flgComplete = false
                return false
              }
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
      if (flgComplete) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    detail1,
    detail2,
    detail3
  }
}
</script>




// WEBPACK FOOTER //
// detailComponent.vue?34230ee3